import { MaximizeIcon } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";
import { ContentCopyButton } from "~/components/ContentCopyButton";
import { MarkdownExportButton } from "~/components/MarkdownExportButton";
import { TabControlBar } from "~/components/TabControlBar";
import { Button } from "~/components/ui/button";
import { stripSourcesFromContent } from "../../helpers";

export const ReportActions = ({
  disabled,
  onMaximize,
  content,
  exportFileName,
  reportTitle,
  caseInfo,
}: {
  disabled: boolean;
  onMaximize: () => void;
  content: string;
  exportFileName: string;
  reportTitle?: string;
  caseInfo?: {
    caseName: string;
    dateOfBirth: string;
    dateOfLoss: string;
    claimNumber: string;
  };
}) => {
  const { formatMessage } = useIntl();
  return (
    <TabControlBar>
      <TabControlBar.Group>
        <Button
          variant="ghost"
          size="mini"
          disabled={disabled}
          onClick={onMaximize}
        >
          <MaximizeIcon className="w-4 h-4 mr-2" />
          <FormattedMessage id="common.maximize" defaultMessage="Maximize" />
        </Button>
        <ContentCopyButton
          content={content}
          size="mini"
          eventName="app/report/copy_all.button/click"
          disabled={disabled}
        />
        <MarkdownExportButton
          content={content}
          fileName={exportFileName}
          disabled={disabled}
          buttonSize="mini"
          openEventName="app/report/export.button/click"
          exportEventName="app/report/export_menu_open/export_action.link/click"
          title={reportTitle || formatMessage({ id: `chat.report.title` })}
          transformContent={stripSourcesFromContent}
          caseInfo={caseInfo}
        />
      </TabControlBar.Group>
    </TabControlBar>
  );
};
